
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contacts",
      function () {
        return require("private-next-pages/contacts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contacts"])
      });
    }
  